import { KEYCODES } from "../config";
import initModules from "../initModules";

class BfvClubSearch {
  constructor(options = {}) {
    this.$root = options.element;
    this.$inputWrapper = this.$root.querySelector(
      ".js-bfv-club-search__clubName",
    );
    this.$clubInput = this.$inputWrapper.querySelector("input");
    this.$hiddenInput = this.$root.querySelector(
      ".js-bfv-club-search__hidden-input input",
    );
    this.$hiddenInputTeam = this.$root.querySelector(
      ".js-bfv-club-search__hidden-input--team input",
    );
    [this.$optionsWrapper] = this.$root.getElementsByClassName(
      "js-bfv-club-options",
    );
    this.apiRoute = this.$root.getAttribute("data-api-url");
    this.apiRouteTeamlist = this.$root.getAttribute("data-api-route");
    this.data = {};
    this.focusedOption = null;
    this.keyDownHandler = this.handleKeyboardNavigationThroughClubs.bind(this);

    this.clubAndTeamSearch = this.$root.classList.contains(
      "js-bfv-club-and-team-search",
    );

    if (this.clubAndTeamSearch) {
      this.$teamInput = this.$root.querySelector(
        ".js-bfv-club-search-team-input input",
      );
      this.$teamInputWrapper = this.$root.querySelector(
        ".js-bfv-club-search-team-input",
      );
      this.$resultList = this.$root.querySelector(
        ".js-bfv-club-search__team-result-list",
      );
    }
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.$clubInput.addEventListener("input", (evt) => {
      if (evt.target.value.length >= 4) {
        this.loadClubs(encodeURIComponent(evt.target.value));
      } else {
        this.$optionsWrapper.classList.add(
          "bfv-club-search__results-wrapper--hidden",
        );
        this.$optionsWrapper.innerHTML = "";
        this.$inputWrapper.classList.remove("input--error");

        if (this.clubAndTeamSearch && evt.target.value.length === 0) {
          this.hideResultList();
          this.hideTeamInputElement();
        }
      }
    });

    this.$clubInput.addEventListener("focus", () => {
      if (this.data.clubs && this.data.clubs.length > 0) {
        this.$inputWrapper.classList.remove("input--error");
        if (this.clubAndTeamSearch) {
          this.hideTeamInputElement();
        }
        this.buildAutoComplete();
      }
    });

    if (this.clubAndTeamSearch) {
      this.$teamInput.addEventListener("click", (evt) => {
        if (evt.target.value.length === 0 && this.$clubInput.value.length > 0) {
          this.hideTeamInputElement();
          this.showResultList();
        }
      });

      this.hideEmptyTeamInput();
      this.hideAutocomplete();

      if (this.$clubInput.value.length === 0) {
        this.hideResultList();
      }
    }
  }

  /**
   * get the clubs, that contain the input string
   * @param val
   */
  loadClubs(val) {
    window.divae.restApi
      .loadData(`${this.apiRoute}?s=${val}`, "")
      .then((_response) => {
        this.data = JSON.parse(_response);

        if (this.data.clubs.length) {
          this.buildAutoComplete();
          this.$inputWrapper.classList.remove("input--error");
        } else {
          this.hideAutocomplete();
          this.hideResultList();
          this.$inputWrapper.classList.add("input--error");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  buildAutoComplete() {
    this.$optionsWrapper.innerHTML = "";
    this.$optionsWrapper.classList.remove(
      "bfv-club-search__results-wrapper--hidden",
    );

    const optionsArray = [];
    Array.prototype.slice.call(this.data.clubs).forEach((element) => {
      optionsArray.push(element);
    });

    if (this.$hiddenInput) {
      this.$hiddenInput.value = null;
    }
    if (this.$hiddenInputTeam) {
      this.$hiddenInputTeam.value = null;
    }

    optionsArray.forEach((option) => {
      const opt = document.createElement("div");
      opt.id = option.id;
      opt.setAttribute("data-club-number", option.number);
      opt.tabIndex = -1;
      opt.innerText = option.name;
      opt.classList.add("bfv-club-search__result-element");
      this.$optionsWrapper.insertBefore(opt, this.$optionsWrapper.firstChild);
    });

    this.bindEventsOnClubs();
    this.bindKeyDownEvents();
    this.autoSelectOnStringMatch(optionsArray);
  }

  hideAutocomplete() {
    this.$optionsWrapper.classList.add(
      "bfv-club-search__results-wrapper--hidden",
    );
    this.$optionsWrapper.innerHTML = "";
  }

  /**
   * if the user manually types an input matching an exact club name, select it
   * @param optionsArray
   */
  autoSelectOnStringMatch(optionsArray) {
    for (let i = 0; i < optionsArray.length; i += 1) {
      if (this.$clubInput.value === optionsArray[i].name) {
        if (this.$hiddenInput) {
          this.$hiddenInput.value = optionsArray[i].id;
        }
        // no need to continue searching, if a match was already found
        if (this.clubAndTeamSearch) {
          this.showTeamResultList();
        }

        break;
      }
    }
  }

  /**
   * write selected club name into input and club id into hidden input,
   * then close the dropdown
   */
  bindEventsOnClubs() {
    const $options = this.$optionsWrapper.getElementsByClassName(
      "bfv-club-search__result-element",
    );

    [...$options].forEach(($option) => {
      $option.addEventListener("click", (event) => {
        event.stopPropagation();
        this.$clubInput.value = event.target.innerText;
        if (this.$hiddenInput) {
          this.$hiddenInput.value = event.target.getAttribute("id");
        }
        if (this.clubAndTeamSearch) {
          this.showTeamResultList();
        }
        this.hideAutocomplete();
      });
    });

    this.handleClickOutsiteTheAutoComplete();
  }

  handleClickOutsiteTheAutoComplete() {
    document.addEventListener("click", (event) => {
      const { target } = event;
      if (!target.isSameNode(this.$clubInput)) {
        this.hideAutocomplete();

        if (this.$clubInput.value && !this.$hiddenInput.value) {
          this.$inputWrapper.classList.add("input--error");
          this.hideResultList();
        }
      }
    });
  }

  bindKeyDownEvents() {
    this.$root.removeEventListener("keydown", this.keyDownHandler);
    this.$root.addEventListener("keydown", this.keyDownHandler);
  }

  /**
   * browse the dropdowns with arrow up and down keys
   * select with enter key
   * @param event
   */
  handleKeyboardNavigationThroughClubs(event) {
    const key = event.keyCode || event.which;
    const $options = this.$optionsWrapper.getElementsByClassName(
      "bfv-club-search__result-element",
    );

    if (key === KEYCODES.DOWN) {
      if (this.focusedOption) {
        this.focusedOption = (this.focusedOption % $options.length) + 1;
      } else {
        this.focusedOption = 1;
      }
    }

    if (key === KEYCODES.UP) {
      if (this.focusedOption) {
        this.focusedOption =
          ((this.focusedOption - $options.length - 1) % $options.length) +
          $options.length;
      } else {
        this.focusedOption = $options.length;
      }
    }

    const $focusedOption = $options[this.focusedOption - 1];

    if (key === KEYCODES.DOWN || key === KEYCODES.UP) {
      event.preventDefault();
      $focusedOption.focus();
    }

    if (key === KEYCODES.ENTER) {
      this.$clubInput.value = $focusedOption.innerText;
      if (this.$hiddenInput) {
        this.$hiddenInput.value = $focusedOption.getAttribute("id");
      }
      if (this.clubAndTeamSearch) {
        this.showTeamResultList();
      }
      this.hideAutocomplete();
    }
  }

  showTeamResultList() {
    const clubId = this.$hiddenInput.value;
    const clubName = this.$clubInput.value;

    const apiUrl = `${this.apiRouteTeamlist}${clubId}`;

    window.divae.restApi
      .loadData(apiUrl, "application/xhtml+xml")
      .then((_response) => {
        this.$resultList.innerHTML = _response;

        initModules({ rootElement: this.$resultList });

        this.$root.querySelector(".js-bfv-club-search__clubName input").value =
          clubName;

        const resultEntries = this.$root.querySelectorAll(
          ".bfv-composition-entry",
        );

        resultEntries.forEach((entry) => {
          entry.addEventListener("click", (ev) => {
            ev.preventDefault();
            this.selectTeam(entry);
          });
        });

        this.hideTeamInputElement();
        this.showResultList();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  selectTeam(entry) {
    this.$teamSelection = entry.querySelector(
      ".bfv-composition-entry__team-name",
    );
    this.showTeamInputElement();
    this.$teamInput.value = this.$teamSelection.innerHTML;
    this.$hiddenInputTeam.value = this.$teamSelection.getAttribute("id");
    this.hideResultList();
  }

  hideResultList() {
    if (this.$resultList) {
      this.$resultList.style.display = "none";
    }
  }

  showResultList() {
    const $results = this.$resultList.querySelector(".bfv-team-search-results");
    if ($results === null) {
      this.showTeamResultList();
    } else {
      this.$resultList.style.display = "block";
    }
  }

  showTeamInputElement() {
    this.$teamInputWrapper.classList.remove(
      "bfv-club-search__team-input-wrapper--hidden",
    );
  }

  hideTeamInputElement() {
    this.$teamInputWrapper.classList.add(
      "bfv-club-search__team-input-wrapper--hidden",
    );
  }

  hideEmptyTeamInput() {
    if (this.$clubInput.value === "") {
      this.hideTeamInputElement();
    }
  }
}

export default BfvClubSearch;

